<style lang="less" scoped>
@import "birthday.less";
</style>
<template>
  <div class="birthday_box">
    <div class="birthday_content">
      <div class="border"></div>
      <div class="birthday_title">高山学员生日</div>
      <div class="months" v-for="item in list" :key="item.month">
        <div class="month_name">{{item.month}}</div>
        <div class="items">
          <div class="item" v-for="person in item.data" :key="person.name">
            <div class="day">{{person.dayNum}}</div>
            <div class="person">
              <div class="name">{{person.name}}</div>
              <div class="company">{{person.company}}</div>
              <!-- <div class="title">职位</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      list: []
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    getDataList: function () {
      let that = this
      this.$http.get('http://gasaapis-dev.gwcevents.com/v3/student/stu_birthday')
        .then(function (res) {
          let map = {}
          res.data.forEach(element => {
            let monthNum = element.birthday.substring(5, 7)
            let dayNum = element.birthday.substring(8, 10)
            element.dayNum = dayNum
            element.number = monthNum + dayNum
            element.birthdayMonth = that.month[monthNum - 1]
          })
          function compare (property) {
            return function (a, b) {
              var value1 = a[property]
              var value2 = b[property]
              return value1 - value2
            }
          }
          let sortlist = res.data.sort(compare('number'))
          sortlist.forEach(element => {
            if (!map[element.birthdayMonth]) {
              map[element.birthdayMonth] = [element]
            } else {
              map[element.birthdayMonth].push(element)
            }
          })
          Object.keys(map).forEach(key => {
            that.list.push({
              month: key,
              data: map[key]
            })
          })
          console.log(that.list)
          // console.log(sortlist)
        })
        .catch(function (err) {
          console.log(err)
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/birthday/birthday.vue